import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageContent } from "@redriver/cinnamon";
import { UploadDownloadTemplate } from "features/DataUploads";
import { useTranslation } from "react-i18next";
import { getAgreementsDealerOfficeState } from "pages/nav/selectors";

const DataUploadsPage = () => {
  const { t } = useTranslation("dataUploads");
  const { name } = useSelector(getAgreementsDealerOfficeState);

  return (
    <PageContent className="data-uploads">
      <h4 className="settings-header">{`${t("header")} - ${name}`}</h4>

      <div className="content-container principal-list users-list">
        <UploadDownloadTemplate />
      </div>
    </PageContent>
  );
};

export default DataUploadsPage;
